import React from 'react';
import { Helmet } from 'react-helmet';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { PLAN_CREATION_REASONS } from '../../../contexts/create-plan-context/create-plan-context-types/plan-create-reason';
import type { PlanCreationStep } from '../../../contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import { PLAN_CREATION_STEPS } from '../../../contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import { CreatePlanProvider } from '../../../contexts/create-plan-context/CreatePlanProvider/CreatePlanProvider';
import { FormErrorNotificationProvider } from '../../../contexts/form-error-notification-context/FormErrorNotificationProvider';
import { useDialog } from '../../../hooks/use-dialog';
import { CreatePlanErrorNotification } from '../CreatePlanPage/create-plan-page-components/CreatePlanErrorNotification/CreatePlanErrorNotification';
import { CreatePlanPageHeader } from '../CreatePlanPage/create-plan-page-components/CreatePlanPageHeader';
import { CreatePlanPageStepperNavigator } from '../CreatePlanPage/create-plan-page-components/CreatePlanPageStepperNavigator';
import { CreatePlanPageTabs } from '../CreatePlanPage/create-plan-page-components/CreatePlanPageTabs/CreatePlanPageTabs';
import { CreatePlanPageContent } from '../CreatePlanPage/create-plan-page-components/NewCreatePlanPageContent/CreatePlanPageContent';
import { PlanSettings } from '../CreatePlanPage/create-plan-page-components/PlanSettings';
import { PLAN_CREATION_STEPS_CTA_LABELS } from '../CreatePlanPage/create-plan-page-consts/create-plan-default-values';
import { UpdatePlanDialog } from './update-plan-page-components/UpdatePlanDialog';
import { withPrefetch } from '../../../components/hocs';
import { prefetchMeters } from '../../../hooks/requests/use-meters/use-meters';
import { UpdatePlanForm } from './update-plan-page-components/UpdatePlanForm/UpdatePlanForm';

const UPDATE_PLAN_STEPS_CONTENT: Record<PlanCreationStep, React.ReactElement> = {
  [PLAN_CREATION_STEPS.pricingAndProducts]: <CreatePlanPageTabs />,
  [PLAN_CREATION_STEPS.settings]: <PlanSettings />,
};

const UpdatePlanPage: React.FC = () => {
  const updatePlanDialogProps = useDialog();

  return (
    <>
      <Helmet>
        <title>Plans</title>
      </Helmet>

      <CreatePlanProvider
        planCreationReason={PLAN_CREATION_REASONS.NewPlan}
        defaultPlanCreationStep={PLAN_CREATION_STEPS.settings}
        onFinalStep={updatePlanDialogProps.handleOpen}
      >
        <UpdatePlanForm>
          <FormErrorNotificationProvider>
            <CreatePlanPageHeader />

            <CreatePlanPageContent stepsContent={UPDATE_PLAN_STEPS_CONTENT} />

            <CreatePlanErrorNotification />

            <CreatePlanPageStepperNavigator stepsLabels={PLAN_CREATION_STEPS_CTA_LABELS} formClearable />

            <UpdatePlanDialog {...updatePlanDialogProps} />
          </FormErrorNotificationProvider>
        </UpdatePlanForm>
      </CreatePlanProvider>
    </>
  );
};

const UpdatePlanPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(withPrefetch(UpdatePlanPage, prefetchMeters)),
);
export { UpdatePlanPageWithSuspenseBoundary as UpdatePlanPage };
